import { Card, Text } from "@overmap-ai/blocks"
import { type IssueAttachment, type Stored } from "@overmap-ai/common"
import { selectUserById } from "@overmap-ai/core"
import { memo } from "react"

import { IssueTimelineItemType } from "../../enums/issues"
import { issueTimelineItemTypeData } from "../../mappings/issues"
import { useAppSelector } from "../../store"
import { formatCompactDate } from "../../utils/date"
import { getUserDisplayLabel } from "../../utils/users"
import { TimelineIconRail } from "../TimelineIconRail/TimelineIconRail"
import type { IssueTimelineSize } from "./typings"

interface IssueTimelineAttachmentItemProps {
	attachment: Stored<IssueAttachment>
	size: IssueTimelineSize
}

export const IssueTimelineAttachmentItem = memo((props: IssueTimelineAttachmentItemProps) => {
	const { attachment, size } = props

	const createdBy = useAppSelector(selectUserById(attachment.created_by ?? -1))

	const { icon } = issueTimelineItemTypeData[IssueTimelineItemType.ISSUE_ATTACHMENT]

	return (
		<div className="flex h-max w-full gap-4">
			<TimelineIconRail icon={icon} size={size} />
			<Card className="flex min-w-0 grow flex-col gap-1" size={size}>
				<Text size={size} accentColor="base">
					<Text highContrast>{getUserDisplayLabel(createdBy)}</Text>
					&nbsp;added an attachment
					<Text accentColor="base">&nbsp;&#8226;&nbsp;{formatCompactDate(attachment.submitted_at)}</Text>
				</Text>

				<Text accentColor="base" className="min-w-0 truncate" size={size} highContrast>
					{attachment.file_name}
				</Text>
			</Card>
		</div>
	)
})
IssueTimelineAttachmentItem.displayName = "IssueTimelineAttachmentItem"
